















































































































































import { Component, Vue } from "vue-property-decorator";
import uploadNew from "@/components/uploadNew.vue";
import api from "@/api";
import {imageUrl} from '@/utils/common'

@Component({
  components: {
    uploadNew: uploadNew
  }
})
export default class AUser extends Vue {
  activeName='order'
  baseUrl = imageUrl
  // 表格数据
  tableData = [];
  // 加载状态
  loading = false;
  // 总条数
  total = 0;
  // 搜索条件
  search: any = {
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };
  config = {}

  model: any = {
    OSSAccessKeyId: "",
    signature: "",
    policy: "",
    key: "",
    callback: "",
    file: "",
    success_action_status: ''
  };

  actions() {
    return "J27136";
  }

  // 搜索 search:true 重置翻页
  searchTable(search = false) {
    this.loading = true;
    if (search) {
      this.search.pagination = {
        pageSize: 20,
        page: 0,
      };
    }
    api
        .post("J27716", this.search)
        .then((data) => {
          this.total = data.total;
          this.tableData = data.list;
        })
        .finally(() => {
          this.loading = false;
        });
  }


  logDialog = false;
  logList = [];
  logTotal = 0;
  listLoading = false;

  lookLogDialog = false;

  // 日志
  openDesc = false
  row = {}
  cancleLog() {
    this.logDialog = false;
  }

  // logTotal = 0
  logSearch = {
    objectId: "",
    objectType: "self_product",
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 10, //每页数量
    },
  };
  logTable = [];
  toLog(item: any) {
    // this.log.dataIndex = this.order.id;
    // this.log.pagination.page = 1;
    this.logSearch.objectId = item.id;
    api.post("J27721", { ...this.logSearch }).then((res) => {
      this.logDialog = true;
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }

  changeLog(page: any) {
    console.log('paaaa', page)
    this.logSearch.pagination.page = page - 1;
    api.post("J27721", { ...this.logSearch }).then((res) => {
      // this.logDialog = true
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }


  logDetail = false
  toLogDetail(row: any) {
    this.logDetail = true;
    this.row = row;
  }

  CloseLogDetailDialog() {
    this.logDetail = false;
  }

  // 新增商品

  add() {
    this.$router.push({
      path: '/integral/commodityEdit'
    })
  }



  // 编辑
  async edit(row:any) {
    this.$router.push({
      path: '/integral/commodityEdit',
      query: {id: row.id}
    })
  }


  // 操作
  setStatus(row: any, val: any){
    // 1 上架  0 下架 2 删除
    let tips: any = val == 0 ? "确定上架该商品?" : (val == 1 ? '确定下架该商品?' : ( val == 2 ? '确定删除该商品?删除后将无法恢复，请谨慎操作' : null ) )
    let apiVal: any = val == 0 ? "J27717" : (val == 1 ? 'J27719' : ( val == 2 ? 'J27714' : null ) )
    this.$confirm( tips , "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      api
          .post(apiVal, {id: row.id})
          .then((res: any) => {
            this.$message.success("操作成功");
            this.searchTable()
          })

    });
  }


  getConfig() {
    api.getJavaConfig().then((res) => {
      this.config = res;
    });
  }

  activated() {
    this.getConfig()
    this.searchTable();
  }
}
